import { IReturnPolicy } from 'src/common/api/return-policy/return-policy-utils';
import { SellingAdditionalData } from 'src/online-items/dto/CartItemActivation';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import { EntryMethod } from '../../../../common/enumerations/entry-method';
import { ItemAddType } from '../../../../common/enumerations/item-add-type';

export interface LineItemAddDto {
  withData: boolean;
  item: {
    id: string;
    entryMethod: EntryMethod;
  };
  quantity: {
    value: number;
    entryMethod?: EntryMethod;
  };
  uomCode: string;
  additionalData?: SellingAdditionalData;
  scanDataType?: number;
  isDepartment?: boolean;
  allowDelayedRestriction?: boolean;
  itemAddType?: ItemAddType;
  tareWeight?: {
    isManualPercentage: boolean;
    isTareOverride: boolean;
    tareValue: number;
    grossWeight: number;
  };
  modifiers?: string[];
  priceModifierType?: PriceModifierType; //SE asks for different modifier type than R10
  newPrice?: number;
  sequenceNumber?: number;
  linkedItems?: LineItemAddDto[];
  returnPolicy?: IReturnPolicy;
  returnType?: ReturnsType;
  serialNumber?: string;
  isTrainingMode?: boolean;
}

export enum PriceModifierType {
  PriceVerify = 'PRICE-VERIFY',
  PriceOverride = 'PRICE-OVERRIDE',
  SpecialPrice = 'SPECIAL-PRICE',
  Discount = 'DISCOUNT',
  Return = 'RETURN',
  ResolveFromBarcode = 'RESOLVE-FROM-BARCODE',
  ResolveFromExternal = 'RESOLVE-FROM-EXTERNAL',
  ManualPrice = 'MANUAL-PRICE',
  EmbeddedPrice = 'EMBEDDED-PRICE',
  ResetPrice = 'RESET-PRICE',
  Other = 'OTHER',
}
